/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type BackofficeUserHistoryUserByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
}>

export type BackofficeUserHistoryUserByIdQuery = {
  __typename?: 'Query'
  backofficeUserById: {
    __typename?: 'BackofficeUser'
    id: string
    email: string
    username: string
  }
}

export type BackofficeUserHistoryFleetsQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type BackofficeUserHistoryFleetsQuery = {
  __typename?: 'Query'
  backofficeUserManagementUserFormDetails: {
    __typename?: 'BackofficeUserManagementUserFormDetails'
    fleets: Array<{
      __typename?: 'BackofficeUserManagementFleet'
      id: string
      name: string
    }>
  }
}

export type BackofficeUserHistoryUserByEmailQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input']
}>

export type BackofficeUserHistoryUserByEmailQuery = {
  __typename?: 'Query'
  backofficeUserByEmail: { __typename?: 'BackofficeUser'; id: string }
}

export type BackofficeUserHistoryViewQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
}>

export type BackofficeUserHistoryViewQuery = {
  __typename?: 'Query'
  backofficeUserHistory: Array<{
    __typename?: 'BackofficeUserManagementUserHistory'
    author: string
    action: string
    affectedAttribute: string
    description: string
    timestamp: string
    userName: string
    notes: string
  }> | null
}

export type BackofficeUserHistoryFragment = {
  __typename?: 'BackofficeUserManagementUserHistory'
  author: string
  action: string
  affectedAttribute: string
  description: string
  timestamp: string
  userName: string
  notes: string
}

export const BackofficeUserHistoryFragmentDoc = gql`
    fragment BackofficeUserHistory on BackofficeUserManagementUserHistory {
  author
  action
  affectedAttribute
  description
  timestamp
  userName
  notes
}
    `
export const BackofficeUserHistoryUserByIdDocument = gql`
    query BackofficeUserHistoryUserById($id: ID!) {
  backofficeUserById(id: $id) {
    id
    email
    username
  }
}
    `

/**
 * __useBackofficeUserHistoryUserByIdQuery__
 *
 * To run a query within a React component, call `useBackofficeUserHistoryUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserHistoryUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeUserHistoryUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackofficeUserHistoryUserByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackofficeUserHistoryUserByIdQuery,
    BackofficeUserHistoryUserByIdQueryVariables
  > &
    (
      | {
          variables: BackofficeUserHistoryUserByIdQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackofficeUserHistoryUserByIdQuery,
    BackofficeUserHistoryUserByIdQueryVariables
  >(BackofficeUserHistoryUserByIdDocument, options)
}
export function useBackofficeUserHistoryUserByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackofficeUserHistoryUserByIdQuery,
    BackofficeUserHistoryUserByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackofficeUserHistoryUserByIdQuery,
    BackofficeUserHistoryUserByIdQueryVariables
  >(BackofficeUserHistoryUserByIdDocument, options)
}
export function useBackofficeUserHistoryUserByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserHistoryUserByIdQuery,
        BackofficeUserHistoryUserByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackofficeUserHistoryUserByIdQuery,
    BackofficeUserHistoryUserByIdQueryVariables
  >(BackofficeUserHistoryUserByIdDocument, options)
}
export type BackofficeUserHistoryUserByIdQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryUserByIdQuery
>
export type BackofficeUserHistoryUserByIdLazyQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryUserByIdLazyQuery
>
export type BackofficeUserHistoryUserByIdSuspenseQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryUserByIdSuspenseQuery
>
export type BackofficeUserHistoryUserByIdQueryResult = Apollo.QueryResult<
  BackofficeUserHistoryUserByIdQuery,
  BackofficeUserHistoryUserByIdQueryVariables
>
export const BackofficeUserHistoryFleetsDocument = gql`
    query BackofficeUserHistoryFleets {
  backofficeUserManagementUserFormDetails {
    fleets {
      id
      name
    }
  }
}
    `

/**
 * __useBackofficeUserHistoryFleetsQuery__
 *
 * To run a query within a React component, call `useBackofficeUserHistoryFleetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserHistoryFleetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeUserHistoryFleetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBackofficeUserHistoryFleetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BackofficeUserHistoryFleetsQuery,
    BackofficeUserHistoryFleetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackofficeUserHistoryFleetsQuery,
    BackofficeUserHistoryFleetsQueryVariables
  >(BackofficeUserHistoryFleetsDocument, options)
}
export function useBackofficeUserHistoryFleetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackofficeUserHistoryFleetsQuery,
    BackofficeUserHistoryFleetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackofficeUserHistoryFleetsQuery,
    BackofficeUserHistoryFleetsQueryVariables
  >(BackofficeUserHistoryFleetsDocument, options)
}
export function useBackofficeUserHistoryFleetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserHistoryFleetsQuery,
        BackofficeUserHistoryFleetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackofficeUserHistoryFleetsQuery,
    BackofficeUserHistoryFleetsQueryVariables
  >(BackofficeUserHistoryFleetsDocument, options)
}
export type BackofficeUserHistoryFleetsQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryFleetsQuery
>
export type BackofficeUserHistoryFleetsLazyQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryFleetsLazyQuery
>
export type BackofficeUserHistoryFleetsSuspenseQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryFleetsSuspenseQuery
>
export type BackofficeUserHistoryFleetsQueryResult = Apollo.QueryResult<
  BackofficeUserHistoryFleetsQuery,
  BackofficeUserHistoryFleetsQueryVariables
>
export const BackofficeUserHistoryUserByEmailDocument = gql`
    query BackofficeUserHistoryUserByEmail($email: String!) {
  backofficeUserByEmail(email: $email) {
    id
  }
}
    `

/**
 * __useBackofficeUserHistoryUserByEmailQuery__
 *
 * To run a query within a React component, call `useBackofficeUserHistoryUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserHistoryUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeUserHistoryUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useBackofficeUserHistoryUserByEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackofficeUserHistoryUserByEmailQuery,
    BackofficeUserHistoryUserByEmailQueryVariables
  > &
    (
      | {
          variables: BackofficeUserHistoryUserByEmailQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackofficeUserHistoryUserByEmailQuery,
    BackofficeUserHistoryUserByEmailQueryVariables
  >(BackofficeUserHistoryUserByEmailDocument, options)
}
export function useBackofficeUserHistoryUserByEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackofficeUserHistoryUserByEmailQuery,
    BackofficeUserHistoryUserByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackofficeUserHistoryUserByEmailQuery,
    BackofficeUserHistoryUserByEmailQueryVariables
  >(BackofficeUserHistoryUserByEmailDocument, options)
}
export function useBackofficeUserHistoryUserByEmailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserHistoryUserByEmailQuery,
        BackofficeUserHistoryUserByEmailQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackofficeUserHistoryUserByEmailQuery,
    BackofficeUserHistoryUserByEmailQueryVariables
  >(BackofficeUserHistoryUserByEmailDocument, options)
}
export type BackofficeUserHistoryUserByEmailQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryUserByEmailQuery
>
export type BackofficeUserHistoryUserByEmailLazyQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryUserByEmailLazyQuery
>
export type BackofficeUserHistoryUserByEmailSuspenseQueryHookResult =
  ReturnType<typeof useBackofficeUserHistoryUserByEmailSuspenseQuery>
export type BackofficeUserHistoryUserByEmailQueryResult = Apollo.QueryResult<
  BackofficeUserHistoryUserByEmailQuery,
  BackofficeUserHistoryUserByEmailQueryVariables
>
export const BackofficeUserHistoryViewDocument = gql`
    query BackofficeUserHistoryView($id: ID!) {
  backofficeUserHistory(id: $id) {
    ...BackofficeUserHistory
  }
}
    ${BackofficeUserHistoryFragmentDoc}`

/**
 * __useBackofficeUserHistoryViewQuery__
 *
 * To run a query within a React component, call `useBackofficeUserHistoryViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserHistoryViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeUserHistoryViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackofficeUserHistoryViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackofficeUserHistoryViewQuery,
    BackofficeUserHistoryViewQueryVariables
  > &
    (
      | { variables: BackofficeUserHistoryViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackofficeUserHistoryViewQuery,
    BackofficeUserHistoryViewQueryVariables
  >(BackofficeUserHistoryViewDocument, options)
}
export function useBackofficeUserHistoryViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackofficeUserHistoryViewQuery,
    BackofficeUserHistoryViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackofficeUserHistoryViewQuery,
    BackofficeUserHistoryViewQueryVariables
  >(BackofficeUserHistoryViewDocument, options)
}
export function useBackofficeUserHistoryViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserHistoryViewQuery,
        BackofficeUserHistoryViewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackofficeUserHistoryViewQuery,
    BackofficeUserHistoryViewQueryVariables
  >(BackofficeUserHistoryViewDocument, options)
}
export type BackofficeUserHistoryViewQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryViewQuery
>
export type BackofficeUserHistoryViewLazyQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryViewLazyQuery
>
export type BackofficeUserHistoryViewSuspenseQueryHookResult = ReturnType<
  typeof useBackofficeUserHistoryViewSuspenseQuery
>
export type BackofficeUserHistoryViewQueryResult = Apollo.QueryResult<
  BackofficeUserHistoryViewQuery,
  BackofficeUserHistoryViewQueryVariables
>
